import { render, staticRenderFns } from "./Featured.vue?vue&type=template&id=1a37ac55&scoped=true"
import script from "./Featured.vue?vue&type=script&lang=js"
export * from "./Featured.vue?vue&type=script&lang=js"
import style0 from "./Featured.vue?vue&type=style&index=0&id=1a37ac55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37ac55",
  null
  
)

export default component.exports